import { getDay } from "date-fns";

import { DAYSOFWEEK } from "./constants";

export function resolveStoreIsOpen(store) {
  let isOpen = false;
  const today = new Date();
  const dayOfWeek = DAYSOFWEEK[getDay(today)];
  if (store.openingHours) {
    store.openingHours.map((hours) => {
      hours.day?.map((day) => {
        if (day.toLowerCase() === dayOfWeek.toLowerCase()) {
          const hhmm = `${`0${today.getHours()}`.slice(-2)}:${`0${today.getMinutes()}`.slice(-2)}`;

          if (hhmm >= hours.opensAt && hhmm < hours.closesAt) {
            isOpen = true;
          }
        }
      });
    });
  }

  return isOpen;
}
